import * as React from "react";
import { CorrectionItem } from "../CorrectionItem";

export const SubjectTypeItem = ({ recordId, isDisabled, onClick, onRemove, correctionSelected, subjectTypeDisplayText }): JSX.Element => {
    return (
        <CorrectionItem
                recordId={recordId}
                title={`Change ${subjectTypeDisplayText}`}
                description={`Change the ${subjectTypeDisplayText} for a single Participant`}
                isDisabled={isDisabled}
                onClick={onClick}
                onRemove={onRemove}
                correctionSelected={correctionSelected}
            />
    );
}
